export default __webpack_public_path__ + "static/media/pactofdread.7e04e47f.png";